import { useEffect } from "react";
import { Link } from "react-router-dom";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import { useT } from "@/i18n/LanguageContext";

export default function LegalPrivacyShell({ titleKey, sections }) {
    const { t } = useT();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="relative min-h-screen bg-[#0D0D1A] text-[#E8E6DF] grain">
            <Navigation />
            <main className="relative z-10 pt-32 pb-24">
                <div className="max-w-[820px] mx-auto px-6 md:px-12">
                    <Link
                        to="/"
                        className="inline-flex items-center gap-2 text-[12px] uppercase tracking-[0.14em] text-[rgba(232,230,223,0.55)] hover:text-[#C9A96E] transition-colors"
                    >
                        <span aria-hidden="true">←</span>
                        {t.legalShared.backHome}
                    </Link>
                    <h1 className="mt-8 font-display text-[36px] md:text-[44px] font-medium leading-[1.1] tracking-[-0.02em]">
                        {titleKey}
                    </h1>
                    <p className="mt-3 text-[12px] uppercase tracking-[0.14em] text-[rgba(232,230,223,0.45)]">
                        {t.legalShared.lastUpdated}
                    </p>

                    <div className="mt-12 space-y-12">
                        {sections.map((s, i) => (
                            <section key={i}>
                                <h2 className="text-[11px] uppercase tracking-[0.14em] text-[#C9A96E] font-medium mb-4">
                                    {s.label}
                                </h2>
                                {s.heading && (
                                    <h3 className="font-display text-[20px] md:text-[22px] font-medium leading-[1.3] tracking-[-0.01em] text-[#E8E6DF] mb-4">
                                        {s.heading}
                                    </h3>
                                )}
                                <div className="text-[15px] leading-[1.75] text-[rgba(232,230,223,0.75)] space-y-4">
                                    {s.body.map((p, j) =>
                                        typeof p === "string" ? (
                                            <p key={j}>{p}</p>
                                        ) : (
                                            <ul
                                                key={j}
                                                className="list-disc pl-5 space-y-2 marker:text-[#C9A96E]"
                                            >
                                                {p.map((li, k) => (
                                                    <li key={k}>{li}</li>
                                                ))}
                                            </ul>
                                        ),
                                    )}
                                </div>
                            </section>
                        ))}
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
}
